import { useRef, useState, useEffect } from 'react';
import { API_ROUTES, clearFlashMessages, setFlashMessage, TRANS_SS_MODES_SAUTER, userIsLogged, userRedirectLogin, DEVICES_LIST_SAUTER } from '../../helpers';
import HousePilotDeviceBox from '../house/pilot/Device_Box';

import $ from 'jquery';
import HouseSauter from './House';
import HousePilotDeviceBoxSS from '../house/pilot/Device_Box_SS';
const REFRESH_INTERVAL = 30 * 1000
let lastUpdateDate

export class HouseSauterManager {
    constructor() {
        this._devicesData = {}
        this._responseTimeNoCache = null
        this._devicesList = null
        this._ejpData = null
        this._setEjpData = null
        this._ejpAutoStop = null
        this._setEjpAutoStop = null
    }

    loadDeviceDataIntoTemplate(clearCache = false) {
        // Load Atlantic data first
        this.loadDevicesData(clearCache).then((data) => {
            if (data?.devices) {
                this._setDevicesData(data.devices)
                this._devicesList = Object.entries(data.devices).map(([key, value]) => ({ name: key, label: value.label }))
            }
            this._devicesDataLoaded = true
        })

    }

    async requestChangeState(deviceName, operationName, operationValue) {
        return new Promise(async (resolve, reject) => {
            console.log('Request change state for device ' + deviceName + ' operation ' + operationName + ' with value ' + operationValue + ' -- ' + API_ROUTES.SAUTER_CHANGE_STATE)
            // If today is EJP and this change is turning a heating device on, ask for confirmation if a hook is provided
            const isTurnOn = (operationName === 'SET_TEMP' && operationValue >= 10) || (deviceName === 'HS_SS' && operationName === 'SET_MODE' && operationValue !== 'off')
            if (isTurnOn && this.isTodayEjp && typeof this.isTodayEjp === 'function' && this.isTodayEjp() === true && this._ejpAutoStop === true) {
                if (this._confirmBeforeTurnOn && typeof this._confirmBeforeTurnOn === 'function') {
                    try {
                        const ok = await this._confirmBeforeTurnOn(deviceName, operationName, operationValue)
                        if (!ok) {
                            // user cancelled
                            resolve()
                            return
                        }
                    } catch (e) {
                        resolve()
                        return
                    }
                }
            }
            const deviceLabel = this._devicesList ? this._devicesList.find(o => o.name === deviceName)?.label : deviceName
            $.post(API_ROUTES.SAUTER_CHANGE_STATE, {
                deviceName: deviceName,
                operation: operationName,
                value: operationValue
            }, (data) => {
                let flashMessage
                if (operationName === 'SET_TEMP') {
                    flashMessage = deviceLabel + ' : '
                    let temperatureMsgPart = 'température changée à ' + operationValue + ' °C'
                    if (data.state === 'STOP') {
                        flashMessage += 'arrêté'
                    } else if (data.state === 'START') {
                        flashMessage += 'démarré et ' + temperatureMsgPart
                    } else {
                        flashMessage += temperatureMsgPart
                    }
                }
                if (operationName === 'SET_MODE' && deviceName === 'HS_SS') {
                    let operationText = operationValue
                    if (TRANS_SS_MODES_SAUTER.hasOwnProperty(operationValue)) {
                        operationText = TRANS_SS_MODES_SAUTER[operationValue]
                    }
                    flashMessage = 'Mode pour ' + deviceLabel + ' changé à ' + operationText.toUpperCase();
                }
                setFlashMessage('success', flashMessage)
                resolve()
            }
            ).fail(error => {
                let msg = 'Echec du changement de statut pour <b>' + deviceName + '</b> operation <b>' + operationName + '</b> avec paramètre <b>' + operationValue + '</b>, <br/>Trace :';
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' ' + JSON.stringify(error.responseJSON.output);
                }
                setFlashMessage('error', msg);
                reject()
            }).always(() => {
                this.loadDeviceDataIntoTemplate()
            });
        })
    }

    // helper to know if today is EJP according to loaded ejpData
    isTodayEjp() {
        if (!this._ejpData || !this._ejpData.states) return false
        const d = new Date()
        const pad = (n) => (n < 10 ? '0' + n : n)
        const key = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
        return this._ejpData.states[key] === 'EJP'
    }

    async loadDevicesData(clearCache = false) {
        return new Promise((resolve, reject) => {
            let url = new URL(API_ROUTES.SAUTER_DEVICES_DATA, window.location.origin)
            if (clearCache === true) {
                url.searchParams.append('cc', 'true')
            }
            $.get(url.toString(), (data) => {
                if (data?.meta?.date) {
                    lastUpdateDate = 'Actualisé ' + data.meta.date
                }
                if (data.meta?.responseTime) {
                    this._responseTimeNoCache = data.meta.responseTime
                }
                resolve(data)
                if ($('#flashMessages div').first().text().includes('Echec du chargement des données')) {
                    clearFlashMessages()
                }
            }
            ).fail(error => {
                let msg = 'Echec du chargement des données';
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' : ' + error.responseJSON.output;
                }
                setFlashMessage('error', msg);
                resolve()
            }).always(() => {
            });
        })
    }



    getDevicesBoxTemplate() {
        const devicesData = this._devicesData
        if (!devicesData) {
            return []
        }

        const deviceBoxes = []

        // Add Atlantic devices if loaded
        if (this._devicesDataLoaded) {
            Object.keys(devicesData)
                .filter(deviceName => deviceName.startsWith('RAD_') || deviceName === 'HS_SS')
                .forEach(deviceName => {
                    const deviceData = devicesData[deviceName]
                    if (deviceName === 'HS_SS') {
                        deviceBoxes.push(<HousePilotDeviceBoxSS
                            key={deviceName}
                            deviceName={deviceName}
                            deviceLabel={deviceData.label}
                            mode={deviceData.targetHeatingLevelState}
                            availableModes={TRANS_SS_MODES_SAUTER}
                            onStateChange={onStateChange}
                            fullSize={true}
                        />)
                    } else {

                        deviceBoxes.push(<HousePilotDeviceBox
                            key={deviceName}
                            isActive={deviceData.isActive}
                            deviceName={deviceName}
                            deviceLabel={deviceData.label}
                            deviceCurrentTemp={deviceData.temperatureState}
                            deviceTargetTemp={deviceData.targetTemperature}
                            mainMode="heating"
                            showModalMetricsTooltip={true}
                            onStateChange={onStateChange}
                            minTargetTemp={10}
                            maxTargetTemp={28}
                        />)
                    }
                })
        }

        return deviceBoxes
    }

    clearDataCache() {
        // Reset response times
        this._responseTimesNoCache = null
        // Load with true to clear all caches
        this.loadDeviceDataIntoTemplate(true)
        this.loadEjpStates(true)
    }

    async loadEjpStates(clearCache = false) {
        return new Promise((resolve, reject) => {
            let url = new URL(API_ROUTES.SAUTER_EJP_STATES, window.location.origin)
            if (clearCache === true) {
                url.searchParams.append('cc', 'true')
            }
            $.get(url.toString(), (data) => {
                // expected shape: { states: { 'YYYY-MM-DD': 'EJP'|'NON_EJP'|... }, dateUpdate: '...' }
                if (this._setEjpData) {
                    this._setEjpData(data)
                }
                this._ejpData = data
                resolve(data)
            }).fail(error => {
                let msg = 'Echec du chargement des données EJP';
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' : ' + error.responseJSON.output;
                }
                setFlashMessage('error', msg);
                resolve()
            })
        })
    }

    loadEjpAutoStop() {
        const url = API_ROUTES.SAUTER_EJP_AUTO_STOP
        $.get(url, (data) => {
            if (this._setEjpAutoStop && data && typeof data.isEnabled !== 'undefined') {
                this._setEjpAutoStop(Boolean(data.isEnabled))
            }
        }).fail(error => {
            let msg = 'Echec du chargement de l\'option EJP Auto-Stop';
            if (error.responseJSON && error.responseJSON.output) {
                msg += ' : ' + error.responseJSON.output;
            }
            setFlashMessage('error', msg);
        })
    }

    setEjpAutoStop(value) {
        $.post(API_ROUTES.SAUTER_EJP_AUTO_STOP, { enabled: value }, (data) => {
            if (this._setEjpAutoStop) {
                this._setEjpAutoStop(Boolean(value))
            }
            setFlashMessage('success', 'EJP Auto-Stop ' + (value ? 'activé' : 'désactivé'))
            // refresh EJP states to reflect any downstream changes
            this.loadEjpStates(true)
        }).fail(error => {
            let msg = 'Echec de la modification de l\'option EJP Auto-Stop';
            if (error.responseJSON && error.responseJSON.output) {
                msg += ' : ' + error.responseJSON.output;
            }
            setFlashMessage('error', msg);
        })
    }
}

const manager = new HouseSauterManager()

async function onStateChange(deviceName, operationName, operationValue) {
    await manager.requestChangeState(deviceName, operationName, operationValue)
}


export default function HouseSauterPilot() {
    const [isLogged, setIsLogged] = useState(false)
    // maintenance check state: checked => we've called backend, active => server in maintenance
    const [maintenanceChecked, setMaintenanceChecked] = useState(false)
    const [maintenanceActive, setMaintenanceActive] = useState(false)
    const [maintenanceMessage, setMaintenanceMessage] = useState(null)

    // EJP Auto-Stop state
    const [ejpAutoStopEnabled, setEjpAutoStopEnabled] = useState(null)
    const [showEjpInfo, setShowEjpInfo] = useState(false)
    const [showConfirmTurnOn, setShowConfirmTurnOn] = useState(false)
    const [confirmDetails, setConfirmDetails] = useState(null)
    const confirmResolverRef = useRef(null)

    if (isLogged !== true) {
        userIsLogged().then((isLogged) => {
            if (isLogged === false) {
                userRedirectLogin()
            }
            setIsLogged(isLogged)
        })
    }

    const [devicesData, setDevicesData] = useState(null)
    const [ejpData, setEjpData] = useState(null)
    let refRefreshIntervalId = useRef(null)


    manager._devicesData = devicesData
    manager._setDevicesData = setDevicesData
    // expose ejp setter for manager and trigger parallel loads
    manager._ejpData = ejpData
    manager._setEjpData = setEjpData
    // expose ejpAutoStop state for manager
    manager._ejpAutoStop = ejpAutoStopEnabled
    manager._setEjpAutoStop = setEjpAutoStopEnabled

    // provide a confirmation hook to manager for turning on heating when today is EJP
    manager._confirmBeforeTurnOn = (deviceName, operationName, operationValue) => {
        return new Promise((resolve) => {
            setConfirmDetails({ deviceName, operationName, operationValue })
            confirmResolverRef.current = resolve
            setShowConfirmTurnOn(true)
        })
    }


    async function checkMaintenance() {
        try {
            const res = await fetch(API_ROUTES.SAUTER_SERVICE_MAINTENANCE, { method: 'GET' })
            const data = await res.json()
            if (typeof data === 'boolean') {
                setMaintenanceActive(Boolean(data))
            } else if (data && typeof data.inMaintenance !== 'undefined') {
                setMaintenanceActive(Boolean(data.inMaintenance))
                if (data.message) setMaintenanceMessage(data.message)
            } else if (data && data === true) {
                setMaintenanceActive(true)
            }
        } catch (e) {
            console.error('Maintenance check failed', e)
        } finally {
            setMaintenanceChecked(true)
        }
    }


    if (!maintenanceChecked) {
        checkMaintenance()
    }



    if (ejpAutoStopEnabled === null) {
        manager.loadEjpAutoStop()
    }

    if (devicesData === null) {
        manager.loadDeviceDataIntoTemplate(false)
    }

    // Load EJP in parallel from devices data — do not block existing data loading
    if (ejpData === null && typeof manager.loadEjpStates === 'function') {
        manager.loadEjpStates(false)
    }

    if (refRefreshIntervalId?.current === null) {
        refRefreshIntervalId.current = setInterval(() => {
            manager.loadDeviceDataIntoTemplate()
        }, REFRESH_INTERVAL)
    }

    function isLoaded() {
        return manager._devicesDataLoaded === true
    }

    const devicesBox = manager.getDevicesBoxTemplate()

    // Prepare compact EJP display
    function _pad(n) { return n < 10 ? '0' + n : n }
    function formatDateKey(d) { return d.getFullYear() + '-' + _pad(d.getMonth() + 1) + '-' + _pad(d.getDate()) }
    function formatDateUpdate(dateStr) {
        if (!dateStr) return null
        const d = new Date(dateStr)
        if (isNaN(d.getTime())) return dateStr
        return _pad(d.getDate()) + '/' + _pad(d.getMonth() + 1) + ' à ' + _pad(d.getHours()) + ':' + _pad(d.getMinutes())
    }

    function isEjp(status) {
        return status === 'EJP'
    }

    function getDeviceLabel(name) {
        // prefer manager's devices list if available
        if (manager._devicesList) {
            const found = manager._devicesList.find(o => o.name === name)
            if (found) return found.label
        }
        const foundStatic = DEVICES_LIST_SAUTER.find(o => o.name === name)
        if (foundStatic) return foundStatic.label
        return name
    }

    function userFriendlyActionLabel(deviceName, operationName, operationValue) {
        if (operationName === 'SET_TEMP') {
            if (operationValue === 'STOP') return 'Arrêt'
            return 'Température ciblée : ' + operationValue + ' °C'
        }
        if (deviceName === 'HS_SS' && operationName === 'SET_MODE') {
            return TRANS_SS_MODES_SAUTER[operationValue] || operationValue
        }
        // fallback
        return operationName + ' ' + operationValue
    }

    const todayKey = formatDateKey(new Date())
    const tomorrow = new Date(); tomorrow.setDate(tomorrow.getDate() + 1)
    const tomorrowKey = formatDateKey(tomorrow)

    const ejpTodayRaw = ejpData && ejpData.states ? ejpData.states[todayKey] : null
    const ejpTomorrowRaw = ejpData && ejpData.states ? ejpData.states[tomorrowKey] : null
    const ejpTodayOui = ejpTodayRaw ? (isEjp(ejpTodayRaw) ? 'OUI' : 'NON') : '—'
    const ejpTomorrowOui = ejpTomorrowRaw ? (isEjp(ejpTomorrowRaw) ? 'OUI' : 'NON') : '—'
    const ejpDateUpdate = ejpData && ejpData.dateUpdate ? formatDateUpdate(ejpData.dateUpdate) : null

    if (isLogged) {
        return (
            <>
                <HouseSauter activeTab="pilotage" />
                {maintenanceActive && (
                    <div className="alert alert-warning text-center" style={{ margin: 0 }} role="alert">
                        Le serveur Cozytouch est indiqué en maintenance actuellement. <br />
                        L'application peut ne pas fonctionner (mais ce sera également le cas sur l'application mobile officielle).
                    </div>
                )}
                <div className="conteneur">
                    <div id="flashMessages"></div>

                    <div id="loader" className="text-center" style={{ display: isLoaded() ? 'none' : 'block' }}>
                        <img style={{ marginTop: "3rem", maxWidth: "128px" }} src={require('../../resources/img/loader3.gif')} />
                    </div>

                    <div id="devicesDataPart" className="text-center" style={{ display: isLoaded() ? 'block' : 'none' }} >

                        {manager._devicesData === null && (
                            <div className="alert alert-danger" role="alert">
                                Aucune donnée disponible. Réésayer plus tard ou rafraichir
                            </div>
                        )}
                        <div className="row ml-1 mr-1 mb-3" id="deviceBoxes">
                            {devicesBox}

                        </div>


                        <div className="text-center mt-3 small"><span id="tableDateUpdate">{lastUpdateDate} </span>
                            <button onClick={() => { manager.loadDeviceDataIntoTemplate() }} className="btn btn-primary btn-sm btn-warn">Rafraichir</button>
                        </div>

                    </div>
                    <div className='row mt-3' style={{ display: devicesData && ejpData?.states ? 'flex' : 'none' }}>
                        <div className="ml-4  deviceBox  col-10 col-md-6'" style={{ background: '#13617e', display: ejpData ? 'block' : 'none' }}>
                            <div className='float-left ml-5'>
                                <h6>EJP Aujourd'hui&nbsp;&nbsp;&nbsp;</h6>
                            </div>
                            <div className='float-right mr-3'>
                                {ejpTodayOui === 'OUI' ? (
                                    <span className="badge badge-danger" style={{ padding: '0.35rem 0.6rem', borderRadius: '0.25rem' }}>{ejpTodayOui}</span>
                                ) : (
                                    <span className="badge badge-secondary" style={{ padding: '0.35rem 0.6rem', borderRadius: '0.25rem' }}>{ejpTodayOui}</span>
                                )}
                            </div>
                            <br />
                            <div className="clearfix"></div>
                            <div className='float-left ml-5'>
                                <h6>EJP Demain&nbsp;&nbsp;&nbsp;</h6>
                            </div>
                            <div className='float-right mr-3'>
                                {ejpTomorrowOui === 'OUI' ? (
                                    <span className="badge badge-danger" style={{ padding: '0.35rem 0.6rem', borderRadius: '0.25rem' }}>{ejpTomorrowOui}</span>
                                ) : (
                                    <span className="badge badge-secondary" style={{ padding: '0.35rem 0.6rem', borderRadius: '0.25rem' }}>{ejpTomorrowOui}</span>
                                )}
                            </div>
                            <div className="clearfix"></div>
                            <div className="text-center">
                                {ejpDateUpdate ? <div className="small">Mis à jour : {ejpDateUpdate}</div> : null}
                            </div>
                            <div className="clearfix"></div>
                            <div className="text-center mt-2">
                                {ejpAutoStopEnabled === null ? (
                                    <div className="small">Chargement option Auto-Stop...</div>
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span style={{ color: 'white', marginRight: '10px', display: 'inline-flex', alignItems: 'center' }}>
                                            EJP Auto-Stop
                                            <i title="Info" className="fa fa-info-circle ml-2" style={{ cursor: 'pointer', color: 'white', marginLeft: '8px', fontSize: '0.95rem' }} onClick={() => setShowEjpInfo(true)} />
                                        </span>
                                        <button
                                            type="button"
                                            className={'btn-toggle' + (ejpAutoStopEnabled ? ' enabled' : '')}
                                            aria-pressed={ejpAutoStopEnabled}
                                            onClick={() => manager.setEjpAutoStop(!ejpAutoStopEnabled)}
                                            style={{ border: 'none', width: 75, height: 30, padding: 0 }}
                                        >
                                            <div className="btn-toggle-content" style={{ width: 32, height: 30 }} />
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* Info modal for EJP Auto-Stop */}
                            {showEjpInfo && (
                                <div onClick={() => setShowEjpInfo(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100002, backdropFilter: 'blur(2px)', pointerEvents: 'auto' }}>
                                    <div onClick={(e) => e.stopPropagation()} className="modal-dialog" role="dialog" aria-modal="true" style={{ background: 'rgba(255,255,255,0.98)', padding: '20px', borderRadius: '8px', maxWidth: '520px', width: '90%', boxShadow: '0 6px 20px rgba(0,0,0,0.18)', color: '#000', pointerEvents: 'auto' }}>
                                        <h5>À propos de l'EJP Auto-Stop</h5>
                                        <div style={{ color: '#000' }}>
                                            <ul>
                                                <li>Arrêt automatique de tout chauffage à 07:00 du matin en cas d'EJP.</li>
                                                <li>Demande de confirmation avant d'allumer un chauffage si l'option est active.</li>
                                            </ul>
                                        </div>
                                        <div className="text-center">
                                            <button className="btn btn-secondary mr-2" onClick={() => setShowEjpInfo(false)}>Fermer</button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Confirmation modal shown when trying to turn on heating on an EJP day */}
                            {showConfirmTurnOn && (
                                <div onClick={() => { setShowConfirmTurnOn(false); if (confirmResolverRef.current) { confirmResolverRef.current(false); confirmResolverRef.current = null } }} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100003, backdropFilter: 'blur(2px)', pointerEvents: 'auto' }}>
                                    <div onClick={(e) => e.stopPropagation()} className="modal-dialog" role="dialog" aria-modal="true" style={{ background: 'rgba(255,255,255,0.98)', padding: '20px', borderRadius: '8px', maxWidth: '520px', width: '90%', boxShadow: '0 6px 20px rgba(0,0,0,0.18)', color: '#000', pointerEvents: 'auto' }}>
                                        <h5>Confirmation requise</h5>
                                        <div style={{ color: '#000' }}>
                                            <p>Aujourd'hui est un jour EJP.<br />Vraiment faire cette opération ?</p>
                                            {confirmDetails && (
                                                <div className="small">
                                                    <p><strong>Appareil :</strong> {getDeviceLabel(confirmDetails.deviceName)}</p>
                                                    <p><strong>Action :</strong> {userFriendlyActionLabel(confirmDetails.deviceName, confirmDetails.operationName, confirmDetails.operationValue)}</p>
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px' }}>
                                            <button className="btn btn-secondary" onClick={() => { setShowConfirmTurnOn(false); if (confirmResolverRef.current) { confirmResolverRef.current(false); confirmResolverRef.current = null } }}>Annuler</button>
                                            <button className="btn btn-danger" onClick={() => { setShowConfirmTurnOn(false); if (confirmResolverRef.current) { confirmResolverRef.current(true); confirmResolverRef.current = null } }}>Confirmer</button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <hr />
                    <div className="text-center mt-2">
                        <button onClick={() => { manager.clearDataCache() }} className="btn btn-secondary btn-sm btn-warn">Vider le cache</button>
                    </div>
                    <div className={"text-center small text-muted mb-3 " + (manager._responseTimeNoCache < 1 ? 'd-none' : '')}>
                        <strong>Temps de réponse sans cache :</strong><br />
                        <span className="mx-2">
                            {manager._responseTimeNoCache} ms
                        </span>

                    </div>
                </div>

            </>)
    }
}
